import React from 'react';
import { PageSection } from 'adc-ui-components';

import HowToReturn from '../HowToReturn';
import ReturnProgress from './ReturnProgress';
import ReturnStatusIndicator from '../ReturnStatusIndicator';
import ReturnDevices from './ReturnDevices';
import ShippingLabels from './ShippingLabels';
import CancelMessage from './CancelMessage';
import { getIsCancelationRequired } from '../../helpers/order';
import LoadingWrapper from '../LoadingWrapper';

const ReturnsDetailStatus = ({
  returnData,
  newLabelLoading,
  handleFetchNewLabel,
}) => {
  if (!returnData) return <LoadingWrapper />;

  const {
    returnInitiation,
    returnOrderId,
    hasPendingLabels,
    returnOrderStatus,
    isXfiPods,
  } = returnData;

  const { shippingLabels, devices, returnInitiationDate } = returnInitiation;
  const hasEnoughLabels = shippingLabels.length >= devices.length;
  const hasReturnedDevice = devices.some(device => !device.deviceFound);
  const orderStatus = (hasReturnedDevice && returnOrderStatus === 'In-Progress') ? 'Completed' : returnOrderStatus;
  const returnReasons = devices.map(device => device.returnReason);

  return (
    <PageSection>
      <h1 className="heading2">Return Details</h1>
      <div className="card-group mb12">
        <div className="card-group__item">
          <div className="card card--action-right-at-768">
            <div className="card__content">
              <p className="heading3">
                {`Return ${returnInitiation.returnSource === 'MyAccount' ? `#${returnOrderId}` : 'Status'}`}
              </p>
            </div>
            <div className="card__action">
              <ReturnStatusIndicator
                useDate={isXfiPods}
                date={returnInitiationDate}
                status={orderStatus}
              />
            </div>
          </div>
        </div>
        {!isXfiPods && (
          <div className="card-group__item">
            <div className="card card--secondary">
              <div className="card__content">
                <ReturnProgress {...returnData} />
              </div>
            </div>
          </div>
        )}

        <ShippingLabels
          labels={shippingLabels}
          loading={newLabelLoading}
          handleFetchNewLabel={handleFetchNewLabel}
          returnOrderId={returnData.returnOrderId}
          showGenerateLabel={hasPendingLabels && !hasEnoughLabels}
        />
      </div>

      {(getIsCancelationRequired(returnReasons) || isXfiPods) && (
        <CancelMessage
          showCancel={getIsCancelationRequired(returnReasons)}
        />
      )}

      {hasPendingLabels && <div className="card-group mb12"><HowToReturn /></div>}

      <div className="card-group mb12">
        <ReturnDevices
          showStatus={!isXfiPods}
          showDeviceSummary={!isXfiPods}
          devices={devices}
          returnInitiation={returnInitiation}
        />
      </div>
    </PageSection>
  );
};

export default ReturnsDetailStatus;
